import Footer from "../component/Footer";
import Nav from "../component/Nav";

export default function OrderTrackingPage() {
  const order = [
    {
      id: "ORD-23901",
      date: "September 18, 2025",
      status: "Delivered", // Processing | Shipped | Delivered
      total: 5000,
      items: [
        {
          id: 1,
          title: "Atomic Habits",
          quantity: 1,
          price: 25.99,
          image:
            "https://images-na.ssl-images-amazon.com/images/I/91bYsX41DVL.jpg",
        },
        {
          id: 2,
          title: "The Psychology of Money",
          quantity: 2,
          price: 19.49,
          image: "https://m.media-amazon.com/images/I/71aG+xDKSYL.jpg",
        },
      ],
    },
    {
      id: "ORD-23901",
      date: "September 18, 2025",
      status: "Delivered", // Processing | Shipped | Delivered
      total: 5000,
      items: [
        {
          id: 1,
          title: "Atomic Habits",
          quantity: 1,
          price: 25.99,
          image:
            "https://images-na.ssl-images-amazon.com/images/I/91bYsX41DVL.jpg",
        },
        {
          id: 2,
          title: "The Psychology of Money",
          quantity: 2,
          price: 19.49,
          image: "https://m.media-amazon.com/images/I/71aG+xDKSYL.jpg",
        },
      ],
    },
  ];

  return (
    <>
      <Nav />
      <br />
      <br />
      <br />
      <div className="order-page">
        <h1 className="order-title">Order Details</h1>
        {order.map((value) => {
          return (
            <div className="order-card">
              <div className="order-header">
                <div>
                  <p>
                    <strong>Order ID:</strong> {value.id}
                  </p>
                  <p>
                    <strong>Order Date:</strong> {value.date}
                  </p>
                </div>
                <span className={`status ${value.status.toLowerCase()}`}>
                  {value.status}
                </span>
              </div>

              <div className="tracker">
                <div className="step completed">Processing</div>
                <div
                  className={`step ${
                    order.status !== "Processing" ? "completed" : ""
                  }`}
                >
                  Shipped
                </div>
                <div
                  className={`step ${
                    order.status === "Delivered" ? "completed" : ""
                  }`}
                >
                  Delivered
                </div>
              </div>

              <div className="order-items">
                {value.items.map((item) => (
                  <div className="order-item" key={item.id}>
                    <img src={item.image} alt={item.title} />
                    <div className="item-info">
                      <h3>{item.title}</h3>
                      <p>Qty: {item.quantity}</p>
                    </div>
                    <p className="item-price">
                      ${(item.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>

              <div className="order-footer">
                <span>Total</span>
                <span className="total">${value?.total.toFixed(2)}</span>
              </div>
            </div>
          );
        })}
      </div>
      <Footer />
    </>
  );
}
